import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=fca82ab0"
import script from "./ResultsPage.vue?vue&type=script&lang=js"
export * from "./ResultsPage.vue?vue&type=script&lang=js"
import style0 from "./ResultsPage.vue?vue&type=style&index=0&id=fca82ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports